import {
    TypedUseSelectorHook,
    // eslint-disable-next-line no-restricted-imports
    useSelector as useSelectorOriginal,
} from 'react-redux'
import {State} from '../state/state'

export const useSelector: TypedUseSelectorHook<State> = useSelectorOriginal
